import { DefineComponent, defineAsyncComponent } from 'vue';

// 使用懒加载方式导入组件，只有在实际使用时才会加载
const modules = import.meta.glob('./*/index.(tsx|vue)');

const components: Record<string, DefineComponent> = {};

for (const path in modules) {
  const componentName = path.split('/')[1];
  // 使用 defineAsyncComponent 实现懒加载，提升首屏加载性能
  components[componentName + 'Ctl'] = defineAsyncComponent({
    loader: modules[path] as any,
    delay: 200,
    timeout: 30000
  });
}

export default components;
